var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 500,
    viewBox: "0 0 450 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M360.877 150H360.699H145.299L150.45 200H355.752C352.743 243.8 343.639 336.596 340.299 378.821L224.987 411.279V411.377L224.732 411.499L109.344 370.898L101.439 275H157.999L162.002 326.575L224.834 350H224.987L287.717 327.502L294.169 250H98.9148C97.9713 239.975 85.8333 109.8 83.7168 100H365.926C364.345 116.5 362.739 133.45 360.877 150ZM0 0L40.9531 453.699L224.732 500L408.996 452.771L450 0H0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.b0c857f0336df48a1e06f0e9fcfd8dd9.svg";
export { ForwardRef as ReactComponent };